export default "__VITE_ASSET__U69uBIF1__"